(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("subscriptionResource", ["$resource", subscriptionResource]);
    function subscriptionResource($resource) {
        return $resource("/api/subscription/:area/:action/:value", { action: "@action", value: "@value" }, {
            getCurrentSubscription: {
                method: "GET",
                params: {
                    action: "getCurrentSubscription"
                }
            },
            getSubscriptionViewModel: {
                method: "GET",
                params: {
                    action: "getSubscriptionViewModel"
                }
            },
            calculateSubscriptionCost: {
                method: "POST",
                params: {
                    action: "calculateSubscriptionCost"
                }
            },
            getCheckout: {
                method: "GET",
                params: {
                    area: "checkout"
                }
            },
            getSubscriptionCheckoutCompletionViewModel: {
                method: "POST",
                params: {
                    action: "getSubscriptionCheckoutCompletionViewModel"
                }
            },
            calculateSubscriptionTaxes: {
                method: "POST",
                params: {
                    area: "checkout",
                    action: "calculateTaxes"
                }
            },
            pay: {
                method: "POST",
                params: {
                    area: "checkout",
                    action: "pay"
                }
            },
            confirmPayPalExpressCheckoutPayment: {
                method: "POST",
                params: {
                    area: "checkout",
                    action: "confirm-paypal-express-checkout"
                }
            },
            complete: {
                method: "POST",
                params: {
                    area: "checkout",
                    action: "complete"
                }
            },
            getBillingHistory: {
                method: "GET",
                params: {
                    action: "getBillingHistory"
                },
                isArray: true
            },
            getInvoiceDetails: {
                method: "GET",
                params: {
                    action: "getInvoiceDetails"
                }
            }
        });
    }
}());
